import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type TReadonlyFieldProps = {
  label: string;
  required?: boolean;
  value: ReactNode;
};

export const ReadonlyField: FC<TReadonlyFieldProps> = ({ label, required, value }) => {
  return (
    <Stack gap="8px" flex={1} minWidth={0}>
      <Typography variant="cap12" color={text.secondary}>
        {label}
        {required && (
          <Typography component="span" color={text.error}>
            {" *"}
          </Typography>
        )}
      </Typography>
      <Typography component="div" variant="body14Semi" color={text.primary}>
        {value ?? "-"}
      </Typography>
    </Stack>
  );
};
